
<template>
  <van-image
    :radius="radius"
    :class="(defineTheme, !src?.length ? 'noimg' : '')"
    :fit="isFinished ? fit : 'contain'"
    :height="height"
    :lazy-load="lazyLoad"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :src="imageSrc"
    :width="width"
    class="animate__fadeIn"
    @error="handleError()"
    @load="loaded($event)"
    :style="`height:${loadingH};`">
    <template #loading v-show="!notLoading">
      <template v-if="!imageSrc">
        <img v-if="isNanTong" alt="暂无图片" :src="defaultImgGay" style="width: 100%; height: 100%; object-fit: cover" />
        <img v-else alt="暂无图片" :src="ImageDefault" style="width: 100%; height: 100%; object-fit: cover" />
      </template>

      <template v-else>
        <img v-if="isNanTong" alt="加载中..." :src="ImageGayLoading"
          style="width: 70%; height: 70%; object-fit: contain" />
        <img v-else alt="加载中..." :src="ImageLoading" style="width: 70%; height: 70%; object-fit: contain"
          :style="`height:${loadingH}`" />
      </template>
    </template>

    <template #error>
      <img v-if="isNanTong" alt="加载失败..." :src="errorImgGay" style="width: 100%; height: 100%; object-fit: cover" />
      <img v-else alt="加载失败..." :src="errorImg?errorImg:ImageError"
        style="width: 100%; height: 100%; object-fit: cover" />
      <span style="display:none;" class="bbb-fff" :data-src="src">
      </span>
    </template>
  </van-image>
</template>

<script lang="ts" setup>
const globalStor = useGlobalStore()
const { defineTheme, curAdvDomain, isNanTong }: any = storeToRefs(globalStor)
import ImageDefault from '@/assets/images/image-default.png'
import ImageLoading from '@/assets/svg/image-loadding.gif'
import ImageGayLoading from "@/assets/svg/nantong/loading.gif"
import ImageError from '@/assets/svg/image-error.svg'
import defaultImgGay from '@/assets/images/light/nantong/defaultImgGay.png'
import errorImgGay from '@/assets/images/light/nantong/errorImgGay.png'
import trackEvent from "@/utils/trackEvent";
import { getBase64ListImg } from '@/utils/tools'

// 设置默认值
const props = withDefaults(
  defineProps<{
    type?: string
    src?: string
    height?: string
    width?: string
    minHeight?: string
    minWidth?: string
    maxHeight?: string
    maxWidth?: string
    fit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
    borderRadius?: string
    lazyLoad?: boolean,
    defaultImg?: boolean,
    errorImg?:string,
    notLoading?: boolean,
    adInfo?: any,
    loadingH?: string;
    radius?: string
  }>(),
  {
    type:'videoImage',
    src: '', // 默认的图片路径
    height: 'auto', // 默认高度
    width: '100%', // 默认宽度
    fit: 'cover', // 默认填充方式
    lazyLoad: true,
    adInfo: '', //广告数据
    loadingH: "", //loading图高度
    radius: '' //图片圆角
  }
)

const loadingH = useModel(props, "loadingH");

const imageSrc = ref(ImageGayLoading);
async function getSrc() {
  if(curAdvDomain.value?.url && props.src && typeof props.src === 'string'){
    const afterFixed = props?.src.split('.').pop();
    if(afterFixed){
      const after = afterFixed.toLowerCase();
      if(['jpg', 'jpeg', 'png', 'gif', 'svg','js','webp','bmp','tif','heic'].includes(after)){
        const result = await getBase64ListImg(props.src,props.type,curAdvDomain.value?.url);
        imageSrc.value = result ? result : '';
      }
    }
  }
}

//是否加载了 base64
const isFinished = computed(() => {
  return imageSrc.value?.includes('base64')
})
//图片加载完成
function loaded() {
  //去除loading添加的高度
  loadingH.value = props.height;
  if(!isFinished.value) getSrc();
}

//图片加载失败
function handleError() {
  const item = props.adInfo
  if (props.adInfo) {
    trackEvent({
      type: "clklog",
      category: "advertise",
      id: item.id,
      name: item.name,
      advertiseType: item.category,
      load_success: 0
    });
  }
}

// 👇 主动暴露
defineExpose({
  imageSrc
})

</script>

<style lang="scss" scoped>
:deep(.van-image__error p) {
  width: 100%;
}

:deep(.van-image__loading) {
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: auto;
  }
}

img {
  max-width: none;
  height: auto;
}

:deep(.van-image__error) {
  width: 100%;
  height: 100%;
  display: inline-block;
  // min-width: 1rem;
  // display: flex;
  // flex-direction: column;

  img {
    width: 100%;
    height: auto;
    // min-width: 1rem;
    min-height: 0.8rem;
    margin-bottom: 0.07rem;
    align-self: center;
  }

  .error-text {
    color: #8b8a92;
    font-size: 0.12rem;
  }
}
</style>
